import React from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'
import logo from '../../assets/logo-text-bottom.png'
import { useLocation } from 'react-router-dom'

export default function Navbar() {
    const location = useLocation()
    if (location?.pathname == '/return') {
        return null
    }

    return (
        <nav className="navbar-container">
            <Link to="/">
                <div className="logo-container">
                    <img
                        className="logo-img"
                        src={logo}
                        alt="Parket"
                    />
                </div>
            </Link>
            <div className="choices-container">
                <Link
                    className="link"
                    to="contact">
                    Join Waitlist
                </Link>
                <Link
                    className="link"
                    to="about">
                    About Us
                </Link>
            </div>
        </nav>
    )
}
